import React from 'react'

import BackToMethodSelectionButton from '../../misc/BackToMethodSelectionButton'
import Faq from '../../faq/FAQ'
import {useI18nContext} from "../../i18n/I18nContext"
import {getI18nTextWithParentKey} from "wipi-common/src/lib/i18n";
import Text from "../../i18n/Text"
import {getEidShowcaseByLanguage} from "wipi-common/src/components/LanguageImageSort";
import InstallAppBanner from "../../misc/InstallAppBanner";
import PropTypes from "prop-types";
import toastWithJam from '../../../assets/illustrations/illu-toast.svg'

export default function UnexpectedError({caseInfo, caseId, isMobileDevice}) {
    const context = useI18nContext()

    return <>
        <div className="col w-100 mb-5 d-flex flex-column justify-content-center align-items-center">
            <img src={toastWithJam} alt="Marmeladenbrot" className="mt-5 mb-5" data-test-id="0df48425-8be8"/>
            <h1><Text k='unexpectedError.error'/></h1>
            <Text k="unexpectedError.tryAgain" data-test-id="eeomcxitr6ga"/>
            <div className="col-xxl-6 col-xl-6 col-md-9 mt-4 ">
                <InstallAppBanner caseId={caseId} isMobileDevice={isMobileDevice}
                                  showcaseImg={getEidShowcaseByLanguage(context.lang)}/>
            </div>
        </div>
        <hr/>
        <BackToMethodSelectionButton caseInfo={caseInfo} isMobileDevice={isMobileDevice}/>
        <Faq faq={getI18nTextWithParentKey(context, 'startEId.faq')}/>
    </>
}
UnexpectedError.propTypes = {
    caseInfo: PropTypes.object.isRequired,
    caseId: PropTypes.string.isRequired,
    isMobileDevice: PropTypes.bool.isRequired
}
